module.exports = __webpack_public_path__ + "img/Primordial-Process-10-mobile.87f84966.png";